module.exports = __webpack_public_path__ + "static/media/A16.74d86bfc.png";